import { useMemo } from 'react';

import { isUSTimezone } from '@/utils/geoDetection';

// Indirection layer: if detection migrates to async (e.g. IP geolocation API),
// only this hook changes — consumers remain unaffected.

export const useIsUSUser = (): boolean => useMemo(() => isUSTimezone(), []);
